import {
  addStagingRecordToLeadBoard,
  addWrittenNewCompaniesToLeadBoard,
  writeApprovedStagingRecords,
  writeStagingRecord,
} from "@/Utile/ncrmStagingApi.mjs";

export const workflowDetailsWriteLeadActions = {
  async writeStagingRecordToCrm(record, { closeDrawer = false } = {}) {
    if (!record?.id) return;
    this.savingStagingRecord = true;
    this.loadingStagingWrite = true;
    this.errorMessage = "";
    try {
      const { data } = await writeStagingRecord(record.id, this.selectedWorkflow?.id);
      await this.fetchStagingRecords();
      this.infoMessage = this.$t("ncrm.workflows.write.rowDone", {
        name: record?.name || record?.external_id || "-",
        action: this.$t(`ncrm.workflows.write.actions.${data?.action || "created"}`),
      });
      if (this.selectedStagingRecord?.id === record.id) {
        const fresh = this.stagingRecords.find((item) => item.id === record.id);
        if (fresh) this.selectedStagingRecord = fresh;
      }
      if (closeDrawer) this.stagingDrawer = false;
    } catch (error) {
      this.errorMessage = error?.response?.data?.error || this.$t("ncrm.workflows.errors.stagingWrite");
    } finally {
      this.savingStagingRecord = false;
      this.loadingStagingWrite = false;
    }
  },
  async handleStagingWrite({ record }) {
    await this.writeStagingRecordToCrm(record, { closeDrawer: true });
  },
  async handleWorkflowWriteRecord(record) {
    await this.writeStagingRecordToCrm(record, { closeDrawer: false });
  },
  async handleWriteApprovedRecords(payload = {}) {
    if (!this.selectedWorkflow?.id) return;
    const stagingIds = Array.isArray(payload.stagingIds) ? payload.stagingIds : null;
    const count = Number(payload.count || stagingIds?.length || 0);
    if (!count) return;
    this.loadingStagingWrite = true;
    this.errorMessage = "";
    try {
      const { data } = await writeApprovedStagingRecords(this.selectedWorkflow.id, stagingIds);
      this.infoMessage = this.$t("ncrm.workflows.write.batchDone", {
        processed: Number(data?.processed || 0),
        created: Number(data?.created || 0),
        updated: Number(data?.updated || 0),
        errors: Array.isArray(data?.errors) ? data.errors.length : 0,
      });
      await this.fetchStagingRecords();
      if (this.selectedStagingRecord?.id) {
        const fresh = this.stagingRecords.find((item) => item.id === this.selectedStagingRecord.id);
        if (fresh) this.selectedStagingRecord = fresh;
      }
    } catch (error) {
      this.errorMessage = error?.response?.data?.error || this.$t("ncrm.workflows.errors.stagingWrite");
    } finally {
      this.loadingStagingWrite = false;
    }
  },
  async handleLeadBoardAddRecord(record) {
    if (!this.selectedWorkflow?.id || !record?.id) return;
    this.loadingStagingLeadBoard = true;
    this.errorMessage = "";
    try {
      await addStagingRecordToLeadBoard(record.id, this.selectedWorkflow.id, {
        boardId: this.leadBoardNodeSettings.boardId,
        stageId: this.leadBoardNodeSettings.stageId,
      });
      await this.fetchStagingRecords();
      this.infoMessage = this.$t("ncrm.workflows.leadBoard.rowDone", {
        name: record?.name || record?.external_id || "-",
      });
    } catch (error) {
      this.errorMessage = error?.response?.data?.error || this.$t("ncrm.workflows.errors.leadBoardAdd");
    } finally {
      this.loadingStagingLeadBoard = false;
    }
  },
  async handleLeadBoardAddBatch(payload = {}) {
    if (!this.selectedWorkflow?.id) return;
    const stagingIds = Array.isArray(payload.stagingIds) ? payload.stagingIds : null;
    const count = Number(payload.count || stagingIds?.length || 0);
    if (!count) return;
    this.loadingStagingLeadBoard = true;
    this.errorMessage = "";
    try {
      const { data } = await addWrittenNewCompaniesToLeadBoard(this.selectedWorkflow.id, stagingIds, {
        boardId: this.leadBoardNodeSettings.boardId,
        stageId: this.leadBoardNodeSettings.stageId,
      });
      await this.fetchStagingRecords();
      this.infoMessage = this.$t("ncrm.workflows.leadBoard.batchDone", {
        processed: Number(data?.processed || 0),
        added: Number(data?.added || 0),
        existing: Number(data?.already_exists || 0),
        errors: Array.isArray(data?.errors) ? data.errors.length : 0,
      });
    } catch (error) {
      this.errorMessage = error?.response?.data?.error || this.$t("ncrm.workflows.errors.leadBoardAdd");
    } finally {
      this.loadingStagingLeadBoard = false;
    }
  },
};
